import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import './_attendance.scss';
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";


const ADD_ATTENDANCE = gql`
  mutation($params: StudentAttendance) {
    addAttendance(params: $params)
  }
`;

const SEND_NOTIFICATION = gql`
  mutation($params: EducationNotifications) {
    sendEduNotification(params: $params)
  }
`;


class SubmitAttendanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      submitError: "",
      loadingSpinner: 0,
    };
  }

  handleFormSubmit = e => {
    e.preventDefault();

    let studentDetails = [];
    (this.props.stateData.getEducationalStudents || []).forEach((item) => {
      const isChanged = isNaN(parseInt(item.attendance_status))
        ? (parseInt(item.value) !== 1)
        : (parseInt(item.value) !== parseInt(item.attendance_status));
      if (isChanged) {
        studentDetails.push({ student_id: item.id, attendance_status: parseInt(item.value) })
      }
    });

    if (studentDetails.length === 0) {
      toast.info("No modifications detected. Override not needed.");
      this.props.onHide();
      return;
    }

    let params = {
      attendance_type_id: parseInt(this.props.stateData.attendanceSearchval.value),
      inserted_time: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
      student_attendance: studentDetails,
      inserted_by: parseInt(Cookies.get("id")),
      class_id: parseInt(this.props.stateData.classSearchval.value)
    };

    this.setState({ loadingSpinner: 1 })
    this.addAttendance(params).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message),
        loadingSpinner: 0
      });
      console.error(
        "ERR =>",
        error.graphQLErrors.map(x => x.message)
      );
      setTimeout(() => {
        this.props.onHide();
      }, 2000);
    });

  };

  addAttendance = async params => {
    console.log("child");
    await this.props.addAttendance({
      variables: {
        params
      },
      update: (store, { data }) => {
        if (data.addAttendance) {
          this.setState({
            currentStep: 2,
            loadingSpinner: 0
          });
          toast.success("Attendance submitted successfully");
        }
      }
    });
  };

  handleNotificationSubmit = async () => {
    let params = {
      date: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
      template_name: "Daily Attendance Status",
      branch_id: this.props.stateData.branchSearchval.value.toString(),
      institute_id: parseInt(Cookies.get("institutionid")),
      notification_type: "attendance",
      section_id: parseInt(this.props.stateData.sectionSearchval.value),
      attendance_subtype_id: parseInt(this.props.stateData.attendanceSearchval.value)
    };

    this.setState({ loadingNotification: 1, submitError: "" });

    try {
      const res = await this.props.sendEduNotification({
        variables: {
          params
        }
      });
      if (res.data.sendEduNotification) {
        toast.success("Notification sent successfully");
        this.setState({ loadingNotification: 0 });
        setTimeout(() => {
          this.SetpageLoad();
        }, 1500);
      } else {
        toast.error("Failed to send notification");
        this.setState({ loadingNotification: 0 });
      }
    } catch (error) {
      console.log("Notification send error", error);
      const errMsg = error.graphQLErrors?.map(x => x.message).join(", ") || error.message || "Failed to send notification";
      this.setState({
        submitError: errMsg,
        loadingNotification: 0
      });
      toast.error(errMsg);
    }
  };

  SetpageLoad = () => {
    this.setState({ currentStep: 1, submitError: "", loadingNotification: 0 });
    this.props.onHide();
    this.props.clearAttendanceData();
    // this.props.onsubmit()
    // this.props.history.push("/student/attendance-report");
  };


  render() {

    const attendanceCards = [
      {
        title: "Total Students",
        value: this.props.stateData.totalStudents,
        icon: "fa-users",
        color: "#4f46e5"
      },
      {
        title: "Present",
        value: this.props.stateData.no_of_present,
        icon: "fa-check",
        color: "#16a34a"
      },
      {
        title: "Absent",
        value: this.props.stateData.no_of_absent,
        icon: "fa-times",
        color: "#ef4444"
      },
      {
        title: "Sick",
        value: this.props.stateData.no_of_sick,
        icon: "fa-medkit",
        color: "#f97316"
      }
    ];

    return (

      <Modal
        {...this.props}
        size="md"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          style={{
            background:
              "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
            color: "#fff",
            borderBottom: "none"
          }}
        >
          <Modal.Title
            className="text-center"
            style={{
              width: "100%",
              fontWeight: "700"
            }}
          >Student Attendance confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">


          <div style={{ padding: "25px" }}>
            {this.state.currentStep === 1 ? (
              <>
                <Row>
                  {
                    attendanceCards.map((item, index) => (
                      <Col sm={6} className="mb-3" key={index}>
                        <div
                          style={{
                            borderRadius: "16px",
                            padding: "18px",
                            textAlign: "center",
                            background: "#fff",
                            borderTop: `5px solid ${item.color}`,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                          }}
                        >
                          <div
                            style={{
                              width: "52px",
                              height: "52px",
                              borderRadius: "50%",
                              border: `2px solid ${item.color}`,
                              color: item.color,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 10px auto",
                              fontSize: "22px"
                            }}
                          >
                            <i className={`fa ${item.icon}`}></i>
                          </div>

                          <h6
                            style={{
                              color: "#4b5563",
                              marginBottom: "5px",
                              fontWeight: "600"
                            }}
                          >
                            {item.title}
                          </h6>

                          <h2
                            style={{
                              margin: 0,
                              color: item.color,
                              fontWeight: "700"
                            }}
                          >
                            {item.value}
                          </h2>
                        </div>
                      </Col>
                    ))
                  }
                </Row>

                {/* Success/Error Message */}
                <div className="text-center mt-2">
                  <p
                    style={{
                      color: "#ef4444",
                      fontWeight: "500",
                      marginBottom: "10px"
                    }}
                  >
                    {this.state.submitError}
                  </p>
                </div>

                {/* Confirm Button */}
                <Button
                  onClick={this.handleFormSubmit}
                  type="submit"
                  style={{
                    width: "100%",
                    background: "linear-gradient(135deg, #10b981, #059669)",
                    border: "none",
                    borderRadius: "14px",
                    padding: "14px",
                    fontWeight: "700",
                    fontSize: "16px",
                    boxShadow: "0 2px 8px rgba(16,185,129,0.3)",
                  }}
                >
                  {
                    this.state.loadingSpinner == 1 ? (
                      <span className="spinner-border spinner-border-sm mr-2"></span>
                    ) : null
                  }

                  Confirm Attendance
                </Button>
              </>
            ) : (
              <>
                {/* Step 2: Success alert and notification options */}
                <div style={{
                  background: "#dcfce7",
                  border: "1px solid #bbf7d0",
                  color: "#166534",
                  borderRadius: "12px",
                  padding: "15px",
                  marginBottom: "20px",
                  textAlign: "center",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px"
                }}>
                  <i className="fa fa-check-circle" style={{ fontSize: "20px" }}></i>
                  Attendance Submitted Successfully!
                </div>

                {/* Absent Students List */}
                {(() => {
                  const absentStudents = (this.props.stateData.getEducationalStudents || [])
                    .filter(student => parseInt(student.value) === 0);

                  if (absentStudents.length > 0) {
                    return (
                      <div style={{ marginBottom: "20px" }}>
                        <h6 style={{ color: "#374151", fontWeight: "700", marginBottom: "10px", textAlign: "left" }}>
                          Absent Students ({absentStudents.length})
                        </h6>
                        <div style={{
                          maxHeight: "150px",
                          overflowY: "auto",
                          border: "1.5px solid #e5e7eb",
                          borderRadius: "12px",
                          padding: "10px 15px",
                          background: "#f9fafb",
                          textAlign: "left",
                          marginBottom: "15px"
                        }}>
                          {absentStudents.map((student, idx) => (
                            <div key={student.id} style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "6px 0",
                              borderBottom: idx === absentStudents.length - 1 ? "none" : "1px solid #f3f4f6",
                              fontSize: "13px",
                              color: "#4b5563"
                            }}>
                              <span style={{ fontWeight: "500" }}>{student.student_name}</span>
                              <span style={{ color: "#9ca3af" }}>Roll: {student.roll_no || "-"}</span>
                            </div>
                          ))}
                        </div>
                        <p style={{ fontSize: "14px", color: "#4b5563", marginTop: "15px", fontWeight: "500", textAlign: "center" }}>
                          Would you like to send attendance notifications to their parents?
                        </p>

                        {this.state.submitError && (
                          <p style={{ color: "#ef4444", fontWeight: "500", marginTop: "10px", marginBottom: "10px", textAlign: "center" }}>
                            {this.state.submitError}
                          </p>
                        )}

                        <Button
                          onClick={this.handleNotificationSubmit}
                          disabled={this.state.loadingNotification === 1}
                          style={{
                            width: "100%",
                            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                            border: "none",
                            borderRadius: "12px",
                            padding: "12px",
                            fontWeight: "700",
                            boxShadow: "0 4px 12px rgba(99,102,241,0.3)",
                            marginBottom: "10px"
                          }}
                        >
                          {this.state.loadingNotification === 1 && <span className="spinner-border spinner-border-sm mr-2"></span>}
                          Send Notification
                        </Button>
                        <Button
                          variant="outline-secondary"
                          onClick={this.SetpageLoad}
                          style={{
                            width: "100%",
                            borderRadius: "12px",
                            padding: "12px",
                            fontWeight: "600"
                          }}
                        >
                          Skip
                        </Button>
                      </div>
                    );
                  } else {
                    return (
                      <div style={{ textAlign: "center" }}>
                        <div style={{
                          textAlign: "center",
                          padding: "20px 0",
                          color: "#15803d",
                          background: "#f0fdf4",
                          borderRadius: "12px",
                          marginBottom: "20px"
                        }}>
                          <i className="fa fa-smile-o" style={{ fontSize: "32px", marginBottom: "8px", display: "block" }}></i>
                          <strong>Perfect Attendance!</strong>
                          <p style={{ margin: 0, fontSize: "13px", color: "#166534" }}>No students are absent today.</p>
                        </div>
                        <Button
                          onClick={() => this.props.history.push("/student/attendance-report")}
                          style={{
                            width: "100%",
                            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                            border: "none",
                            borderRadius: "12px",
                            padding: "12px",
                            fontWeight: "700",
                            boxShadow: "0 4px 12px rgba(99,102,241,0.3)"
                          }}
                        >
                          Go to Report
                        </Button>
                      </div>
                    );
                  }
                })()}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
export default withRouter(
  compose(
    graphql(ADD_ATTENDANCE, {
      name: "addAttendance"
    }),
    graphql(SEND_NOTIFICATION, {
      name: "sendEduNotification"
    })
  )(SubmitAttendanceModal)
);